module.exports = __webpack_public_path__ + "static/img/dyjs_zzfx_icon.png";